// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CGMChart-module__font-s-10___kPrdD {
  font-size: 10px !important;
}

.CGMChart-module__font-s-12___zFFiW {
  font-size: 12px !important;
}

.CGMChart-module__font-s-13___yYayP {
  font-size: 13px !important;
}

.CGMChart-module__font-s-14___lu03N {
  font-size: 14px !important;
}

.CGMChart-module__font-s-15___imsj5 {
  font-size: 15px !important;
}

.CGMChart-module__font-s-16___ZREOO {
  font-size: 16px !important;
}

.CGMChart-module__font-s-18____6XLR {
  font-size: 18px !important;
}

.CGMChart-module__font-s-20___hevH5 {
  font-size: 20px !important;
}

.CGMChart-module__font-s-22___QPF4F {
  font-size: 22px !important;
}

.CGMChart-module__font-s-28___sD5xr {
  font-size: 28px !important;
}

.CGMChart-module__font-w-400___KOfN0 {
  font-weight: 400 !important;
}

.CGMChart-module__font-w-500___Pnje6 {
  font-weight: 500 !important;
}

.CGMChart-module__font-w-600___BGH70 {
  font-weight: 600 !important;
}

.CGMChart-module__font-w-700___zTVpG {
  font-weight: 700 !important;
}

.CGMChart-module__p-5___t1KHN {
  padding: 5px !important;
}

.CGMChart-module__p-12___WyXVI {
  padding: 12px !important;
}

.CGMChart-module__p-16___IXmes {
  padding: 16px !important;
}

.CGMChart-module__p-30___eBIBI {
  padding: 30px !important;
}

.CGMChart-module__p-b-0___Y_TAg {
  padding-bottom: 0 !important;
}

.CGMChart-module__p-b-5___GMCCZ {
  padding-bottom: 5px !important;
}

.CGMChart-module__p-b-10___Vi82Y {
  padding-bottom: 10px !important;
}

.CGMChart-module__p-b-12___nx4H_ {
  padding-bottom: 12px !important;
}

.CGMChart-module__p-b-16___OHii8 {
  padding-bottom: 16px !important;
}

.CGMChart-module__p-b-18___VnBQD {
  padding-bottom: 18px !important;
}

.CGMChart-module__p-b-20___YTUwz {
  padding-bottom: 20px !important;
}

.CGMChart-module__p-b-25___qwO6I {
  padding-bottom: 25px !important;
}

.CGMChart-module__p-b-30___cfVqK {
  padding-bottom: 30px !important;
}

.CGMChart-module__p-b-50___br7aG {
  padding-bottom: 50px !important;
}

.CGMChart-module__p-t-0___wm4XE {
  padding-top: 0 !important;
}

.CGMChart-module__p-t-12___bxfF6 {
  padding-top: 12px !important;
}

.CGMChart-module__p-t-16___v1KkG {
  padding-top: 16px !important;
}

.CGMChart-module__p-t-18___RO55c {
  padding-top: 18px !important;
}

.CGMChart-module__p-t-20___uERXt {
  padding-top: 20px !important;
}

.CGMChart-module__p-t-30___DEs8A {
  padding-top: 30px !important;
}

.CGMChart-module__p-t-40___wwTv4 {
  padding-top: 40px !important;
}

.CGMChart-module__p-t-50___UAeKF {
  padding-top: 50px !important;
}

.CGMChart-module__p-l-20___JdUtz {
  padding-left: 20px !important;
}

.CGMChart-module__p-l-30___qWr5q {
  padding-left: 30px !important;
}

.CGMChart-module__p-l-40___mC0Ua {
  padding-left: 40px !important;
}

.CGMChart-module__p-r-16___uyPqc {
  padding-right: 16px !important;
}

.CGMChart-module__p-r-20___sZ5t5 {
  padding-right: 20px !important;
}

.CGMChart-module__p-r-30___E8WKi {
  padding-right: 30px !important;
}

.CGMChart-module__p-r-50___PuSV9 {
  padding-right: 50px !important;
}

.CGMChart-module__p-r-60___SdSW_ {
  padding-right: 60px !important;
}

.CGMChart-module__m-b-1___hRa7Z {
  margin-bottom: 1px !important;
}

.CGMChart-module__m-b-2___l466V {
  margin-bottom: 2px !important;
}

.CGMChart-module__m-b-6___sU3O2 {
  margin-bottom: 6px !important;
}

.CGMChart-module__m-b-8___zxrV3 {
  margin-bottom: 8px !important;
}

.CGMChart-module__m-b-10___FhW0n {
  margin-bottom: 10px !important;
}

.CGMChart-module__m-b-14___URCRG {
  margin-bottom: 14px !important;
}

.CGMChart-module__m-b-16___xjlHq {
  margin-bottom: 16px !important;
}

.CGMChart-module__m-b-20___zESZn {
  margin-bottom: 20px !important;
}

.CGMChart-module__m-b-22___WJVOe {
  margin-bottom: 22px !important;
}

.CGMChart-module__m-b-24___Cgr7W {
  margin-bottom: 24px !important;
}

.CGMChart-module__m-b-30___u3MXf {
  margin-bottom: 30px !important;
}

.CGMChart-module__m-b-32___UdDsG {
  margin-bottom: 32px !important;
}

.CGMChart-module__m-b-40___lfbKH {
  margin-bottom: 40px !important;
}

.CGMChart-module__m-t-2___FvTe2 {
  margin-top: 2px !important;
}

.CGMChart-module__m-t-3___WmMPz {
  margin-top: 3px !important;
}

.CGMChart-module__m-t-4___ZKMEd {
  margin-top: 4px !important;
}

.CGMChart-module__m-t-5___GYTqY {
  margin-top: 5px !important;
}

.CGMChart-module__m-t-8___Fu0Ze {
  margin-top: 8px !important;
}

.CGMChart-module__m-t-10___kYjSw {
  margin-top: 10px !important;
}

.CGMChart-module__m-t-15___UFsP8 {
  margin-top: 15px !important;
}

.CGMChart-module__m-t-16___wrWhs {
  margin-top: 16px !important;
}

.CGMChart-module__m-t-20___M0NQi {
  margin-top: 20px !important;
}

.CGMChart-module__m-t-22___W5q4m {
  margin-top: 22px !important;
}

.CGMChart-module__m-t-30___YfxZQ {
  margin-top: 30px !important;
}

.CGMChart-module__m-t-32___a_POb {
  margin-top: 32px !important;
}

.CGMChart-module__m-l-auto___OCXvm {
  margin-left: auto !important;
}

.CGMChart-module__m-l-4___KVkb9 {
  margin-left: 4px !important;
}

.CGMChart-module__m-l-5___ZaMZX {
  margin-left: 5px !important;
}

.CGMChart-module__m-l-6___Ypous {
  margin-left: 6px !important;
}

.CGMChart-module__m-l-8___OmKiI {
  margin-left: 8px !important;
}

.CGMChart-module__m-l-10___GbKmo {
  margin-left: 10px !important;
}

.CGMChart-module__m-l-16___xQBkq {
  margin-left: 16px !important;
}

.CGMChart-module__m-l-20___3_5Ds {
  margin-left: 20px !important;
}

.CGMChart-module__m-l-24___YEZAV {
  margin-left: 24px !important;
}

.CGMChart-module__m-l-30___pQoUz {
  margin-left: 30px !important;
}

.CGMChart-module__m-l-35___F0vXD {
  margin-left: 35px !important;
}

.CGMChart-module__m-l-40___uL_Nc {
  margin-left: 40px !important;
}

.CGMChart-module__m-r-8___zbOMw {
  margin-right: 8px !important;
}

.CGMChart-module__m-r-10___ATyRp {
  margin-right: 10px !important;
}

.CGMChart-module__m-r-16___hmE8b {
  margin-right: 16px !important;
}

.CGMChart-module__m-r-20___u2pwG {
  margin-right: 20px !important;
}

.CGMChart-module__m-r-24___OD9Wt {
  margin-right: 24px !important;
}

.CGMChart-module__m-r-30___ApHzJ {
  margin-right: 30px !important;
}

.CGMChart-module__m-r-40___NFMKc {
  margin-right: 40px !important;
}

.CGMChart-module__border-r-3___ENAK2 {
  border-radius: 3px !important;
}

.CGMChart-module__border-r-4___cYL9d {
  border-radius: 4px !important;
}

.CGMChart-module__border-r-6___ISJW2 {
  border-radius: 6px !important;
}

.CGMChart-module__border-r-10___OyKvl {
  border-radius: 10px !important;
}

.CGMChart-module__border-r-12___uxKu_ {
  border-radius: 12px !important;
}

.CGMChart-module__border-r-16___Sa_ib {
  border-radius: 16px !important;
}

.CGMChart-module__border-r-50___RURgM {
  border-radius: 50% !important;
}

.CGMChart-module__primary-border___uyVid {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.CGMChart-module__primary-border-b___RwJGq {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.CGMChart-module__primary-border-t___YIuWp {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.CGMChart-module__primary-border-l___bTzm3 {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.CGMChart-module__primary-border-r___T9ARb {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.CGMChart-module__secondary-border____H9rR {
  border: 1px solid #637768;
}

.CGMChart-module__secondary-border-b____gdNb {
  border-bottom: 1px solid #637768;
}

.CGMChart-module__secondary-border-t___pdHvT {
  border-top: 1px solid #637768;
}

.CGMChart-module__secondary-border-l___T8Hmz {
  border-left: 1px solid #637768;
}

.CGMChart-module__secondary-border-r___W_RZx {
  border-right: 1px solid #637768;
}

.CGMChart-module__gap-0___v479K {
  gap: 0 !important;
}

.CGMChart-module__gap-2___ZJW3h {
  gap: 2px !important;
}

.CGMChart-module__gap-4___eezc3 {
  gap: 4px !important;
}

.CGMChart-module__gap-5___oKiiC {
  gap: 5px !important;
}

.CGMChart-module__gap-6___dHhhU {
  gap: 6px !important;
}

.CGMChart-module__gap-8___QW1um {
  gap: 8px !important;
}

.CGMChart-module__gap-10___vveuL {
  gap: 10px !important;
}

.CGMChart-module__gap-12___RYpOA {
  gap: 12px !important;
}

.CGMChart-module__gap-14___HiNja {
  gap: 14px !important;
}

.CGMChart-module__gap-16___mo10R {
  gap: 16px !important;
}

.CGMChart-module__gap-18___FHdLF {
  gap: 18px !important;
}

.CGMChart-module__gap-20___dt0aR {
  gap: 20px !important;
}

.CGMChart-module__gap-24___vcoSW {
  gap: 24px !important;
}

.CGMChart-module__gap-26___oX9O6 {
  gap: 26px !important;
}

.CGMChart-module__gap-30___zHxS1 {
  gap: 30px !important;
}

.CGMChart-module__gap-32___mIYIn {
  gap: 32px !important;
}

.CGMChart-module__gap-40___X_W1x {
  gap: 40px !important;
}

.CGMChart-module__gap-50___D_A3e {
  gap: 50px !important;
}

.CGMChart-module__flex-1___Gg_Ht {
  flex: 1;
}

.CGMChart-module__flex-none___ZVXdM {
  flex: none !important;
}

.CGMChart-module__flex-column___CTI0J {
  display: flex;
  flex-direction: column !important;
}

.CGMChart-module__flex-row___qYUXi {
  display: flex;
  flex-direction: row !important;
}

.CGMChart-module__vertically-centered___i7MkL {
  display: flex;
  align-items: center !important;
}

.CGMChart-module__horizontally-centered___jKmZp {
  display: flex;
  justify-content: center !important;
}

.CGMChart-module__horizontally-end___AQHKb {
  display: flex;
  justify-content: end !important;
}

.CGMChart-module__vertically-start___Tydd2 {
  display: flex;
  align-items: start !important;
}

.CGMChart-module__space-between___DdRju {
  display: flex;
  justify-content: space-between !important;
}

.CGMChart-module__flex-wrap___escd5 {
  flex-wrap: wrap !important;
}

.CGMChart-module__height-100___D55rQ {
  height: 100%;
}

.CGMChart-module__width-50___mj6i5 {
  width: 50% !important;
}

.CGMChart-module__width-100___vElk5 {
  width: 100%;
}

.CGMChart-module__cursor-pointer___KznID {
  cursor: pointer;
}

.CGMChart-module__cursor-not-allowed___PAAIz {
  cursor: not-allowed !important;
}

.CGMChart-module__absolute-centered___zpsz1 {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.CGMChart-module__absolute___Csnfq {
  position: absolute;
}

.CGMChart-module__relative___vHPMI {
  position: relative;
}

.CGMChart-module__fixed___BQBA_ {
  position: fixed;
}

.CGMChart-module__visible___ml6Bk {
  opacity: 1;
}

.CGMChart-module__invisible___T7V2S {
  opacity: 0;
}

.CGMChart-module__col-90___uGOJ9 {
  width: 90% !important;
}

.CGMChart-module__col-auto___PU8ZG {
  width: auto !important;
}

.CGMChart-module__medical-tabs___wbPji {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.CGMChart-module__medical-table-new___BmNfv {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.CGMChart-module__medical-table-new___BmNfv:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.CGMChart-module__medical-table-new___BmNfv::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.CGMChart-module__medical-table-new___BmNfv::-webkit-scrollbar-track {
  display: none;
}
.CGMChart-module__medical-table-new___BmNfv.CGMChart-module__no-pagination___AuXc7 {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.CGMChart-module__medical-table-new___BmNfv.CGMChart-module__no-pagination___AuXc7:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.CGMChart-module__medical-table-new___BmNfv.CGMChart-module__no-pagination___AuXc7::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.CGMChart-module__medical-table-new___BmNfv.CGMChart-module__no-pagination___AuXc7::-webkit-scrollbar-track {
  display: none;
}

.CGMChart-module__medical-table-empty___h1Lam {
  padding: 14px 40px !important;
}

.CGMChart-module__icon-btn___XGbNd {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.CGMChart-module__search-icon___uQ8bB {
  width: 24px;
  height: 24px;
  align-self: center;
}

.CGMChart-module__disable-select___CGYqU {
  user-select: none;
}

.CGMChart-module__break-word___GrJWY {
  word-break: break-word;
}

.CGMChart-module__popup-clear-btn___iIfiy {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.CGMChart-module__scroll-m-b-20___IZVLI {
  scroll-margin-bottom: 20px;
}

.CGMChart-module__chart___OGODp {
  width: 100%;
  height: 40vh;
  position: relative;
}
.CGMChart-module__chart___OGODp .CGMChart-module__emptyPlaceholder___bZQkh {
  color: #375844;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/PatientDetails/fragments/Biometrics/charts/CGMChart/CGMChart.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AA8pBF;AA5pBE;EACE,cAAA;AA8pBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.chart {\n  width: 100%;\n  height: 40vh;\n  position: relative;\n\n  .emptyPlaceholder {\n    color: get-color(greenNew, dark);\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `CGMChart-module__font-s-10___kPrdD`,
	"fontS12": `CGMChart-module__font-s-12___zFFiW`,
	"fontS13": `CGMChart-module__font-s-13___yYayP`,
	"fontS14": `CGMChart-module__font-s-14___lu03N`,
	"fontS15": `CGMChart-module__font-s-15___imsj5`,
	"fontS16": `CGMChart-module__font-s-16___ZREOO`,
	"fontS18": `CGMChart-module__font-s-18____6XLR`,
	"fontS20": `CGMChart-module__font-s-20___hevH5`,
	"fontS22": `CGMChart-module__font-s-22___QPF4F`,
	"fontS28": `CGMChart-module__font-s-28___sD5xr`,
	"fontW400": `CGMChart-module__font-w-400___KOfN0`,
	"fontW500": `CGMChart-module__font-w-500___Pnje6`,
	"fontW600": `CGMChart-module__font-w-600___BGH70`,
	"fontW700": `CGMChart-module__font-w-700___zTVpG`,
	"p5": `CGMChart-module__p-5___t1KHN`,
	"p12": `CGMChart-module__p-12___WyXVI`,
	"p16": `CGMChart-module__p-16___IXmes`,
	"p30": `CGMChart-module__p-30___eBIBI`,
	"pB0": `CGMChart-module__p-b-0___Y_TAg`,
	"pB5": `CGMChart-module__p-b-5___GMCCZ`,
	"pB10": `CGMChart-module__p-b-10___Vi82Y`,
	"pB12": `CGMChart-module__p-b-12___nx4H_`,
	"pB16": `CGMChart-module__p-b-16___OHii8`,
	"pB18": `CGMChart-module__p-b-18___VnBQD`,
	"pB20": `CGMChart-module__p-b-20___YTUwz`,
	"pB25": `CGMChart-module__p-b-25___qwO6I`,
	"pB30": `CGMChart-module__p-b-30___cfVqK`,
	"pB50": `CGMChart-module__p-b-50___br7aG`,
	"pT0": `CGMChart-module__p-t-0___wm4XE`,
	"pT12": `CGMChart-module__p-t-12___bxfF6`,
	"pT16": `CGMChart-module__p-t-16___v1KkG`,
	"pT18": `CGMChart-module__p-t-18___RO55c`,
	"pT20": `CGMChart-module__p-t-20___uERXt`,
	"pT30": `CGMChart-module__p-t-30___DEs8A`,
	"pT40": `CGMChart-module__p-t-40___wwTv4`,
	"pT50": `CGMChart-module__p-t-50___UAeKF`,
	"pL20": `CGMChart-module__p-l-20___JdUtz`,
	"pL30": `CGMChart-module__p-l-30___qWr5q`,
	"pL40": `CGMChart-module__p-l-40___mC0Ua`,
	"pR16": `CGMChart-module__p-r-16___uyPqc`,
	"pR20": `CGMChart-module__p-r-20___sZ5t5`,
	"pR30": `CGMChart-module__p-r-30___E8WKi`,
	"pR50": `CGMChart-module__p-r-50___PuSV9`,
	"pR60": `CGMChart-module__p-r-60___SdSW_`,
	"mB1": `CGMChart-module__m-b-1___hRa7Z`,
	"mB2": `CGMChart-module__m-b-2___l466V`,
	"mB6": `CGMChart-module__m-b-6___sU3O2`,
	"mB8": `CGMChart-module__m-b-8___zxrV3`,
	"mB10": `CGMChart-module__m-b-10___FhW0n`,
	"mB14": `CGMChart-module__m-b-14___URCRG`,
	"mB16": `CGMChart-module__m-b-16___xjlHq`,
	"mB20": `CGMChart-module__m-b-20___zESZn`,
	"mB22": `CGMChart-module__m-b-22___WJVOe`,
	"mB24": `CGMChart-module__m-b-24___Cgr7W`,
	"mB30": `CGMChart-module__m-b-30___u3MXf`,
	"mB32": `CGMChart-module__m-b-32___UdDsG`,
	"mB40": `CGMChart-module__m-b-40___lfbKH`,
	"mT2": `CGMChart-module__m-t-2___FvTe2`,
	"mT3": `CGMChart-module__m-t-3___WmMPz`,
	"mT4": `CGMChart-module__m-t-4___ZKMEd`,
	"mT5": `CGMChart-module__m-t-5___GYTqY`,
	"mT8": `CGMChart-module__m-t-8___Fu0Ze`,
	"mT10": `CGMChart-module__m-t-10___kYjSw`,
	"mT15": `CGMChart-module__m-t-15___UFsP8`,
	"mT16": `CGMChart-module__m-t-16___wrWhs`,
	"mT20": `CGMChart-module__m-t-20___M0NQi`,
	"mT22": `CGMChart-module__m-t-22___W5q4m`,
	"mT30": `CGMChart-module__m-t-30___YfxZQ`,
	"mT32": `CGMChart-module__m-t-32___a_POb`,
	"mLAuto": `CGMChart-module__m-l-auto___OCXvm`,
	"mL4": `CGMChart-module__m-l-4___KVkb9`,
	"mL5": `CGMChart-module__m-l-5___ZaMZX`,
	"mL6": `CGMChart-module__m-l-6___Ypous`,
	"mL8": `CGMChart-module__m-l-8___OmKiI`,
	"mL10": `CGMChart-module__m-l-10___GbKmo`,
	"mL16": `CGMChart-module__m-l-16___xQBkq`,
	"mL20": `CGMChart-module__m-l-20___3_5Ds`,
	"mL24": `CGMChart-module__m-l-24___YEZAV`,
	"mL30": `CGMChart-module__m-l-30___pQoUz`,
	"mL35": `CGMChart-module__m-l-35___F0vXD`,
	"mL40": `CGMChart-module__m-l-40___uL_Nc`,
	"mR8": `CGMChart-module__m-r-8___zbOMw`,
	"mR10": `CGMChart-module__m-r-10___ATyRp`,
	"mR16": `CGMChart-module__m-r-16___hmE8b`,
	"mR20": `CGMChart-module__m-r-20___u2pwG`,
	"mR24": `CGMChart-module__m-r-24___OD9Wt`,
	"mR30": `CGMChart-module__m-r-30___ApHzJ`,
	"mR40": `CGMChart-module__m-r-40___NFMKc`,
	"borderR3": `CGMChart-module__border-r-3___ENAK2`,
	"borderR4": `CGMChart-module__border-r-4___cYL9d`,
	"borderR6": `CGMChart-module__border-r-6___ISJW2`,
	"borderR10": `CGMChart-module__border-r-10___OyKvl`,
	"borderR12": `CGMChart-module__border-r-12___uxKu_`,
	"borderR16": `CGMChart-module__border-r-16___Sa_ib`,
	"borderR50": `CGMChart-module__border-r-50___RURgM`,
	"primaryBorder": `CGMChart-module__primary-border___uyVid`,
	"primaryBorderB": `CGMChart-module__primary-border-b___RwJGq`,
	"primaryBorderT": `CGMChart-module__primary-border-t___YIuWp`,
	"primaryBorderL": `CGMChart-module__primary-border-l___bTzm3`,
	"primaryBorderR": `CGMChart-module__primary-border-r___T9ARb`,
	"secondaryBorder": `CGMChart-module__secondary-border____H9rR`,
	"secondaryBorderB": `CGMChart-module__secondary-border-b____gdNb`,
	"secondaryBorderT": `CGMChart-module__secondary-border-t___pdHvT`,
	"secondaryBorderL": `CGMChart-module__secondary-border-l___T8Hmz`,
	"secondaryBorderR": `CGMChart-module__secondary-border-r___W_RZx`,
	"gap0": `CGMChart-module__gap-0___v479K`,
	"gap2": `CGMChart-module__gap-2___ZJW3h`,
	"gap4": `CGMChart-module__gap-4___eezc3`,
	"gap5": `CGMChart-module__gap-5___oKiiC`,
	"gap6": `CGMChart-module__gap-6___dHhhU`,
	"gap8": `CGMChart-module__gap-8___QW1um`,
	"gap10": `CGMChart-module__gap-10___vveuL`,
	"gap12": `CGMChart-module__gap-12___RYpOA`,
	"gap14": `CGMChart-module__gap-14___HiNja`,
	"gap16": `CGMChart-module__gap-16___mo10R`,
	"gap18": `CGMChart-module__gap-18___FHdLF`,
	"gap20": `CGMChart-module__gap-20___dt0aR`,
	"gap24": `CGMChart-module__gap-24___vcoSW`,
	"gap26": `CGMChart-module__gap-26___oX9O6`,
	"gap30": `CGMChart-module__gap-30___zHxS1`,
	"gap32": `CGMChart-module__gap-32___mIYIn`,
	"gap40": `CGMChart-module__gap-40___X_W1x`,
	"gap50": `CGMChart-module__gap-50___D_A3e`,
	"flex1": `CGMChart-module__flex-1___Gg_Ht`,
	"flexNone": `CGMChart-module__flex-none___ZVXdM`,
	"flexColumn": `CGMChart-module__flex-column___CTI0J`,
	"flexRow": `CGMChart-module__flex-row___qYUXi`,
	"verticallyCentered": `CGMChart-module__vertically-centered___i7MkL`,
	"horizontallyCentered": `CGMChart-module__horizontally-centered___jKmZp`,
	"horizontallyEnd": `CGMChart-module__horizontally-end___AQHKb`,
	"verticallyStart": `CGMChart-module__vertically-start___Tydd2`,
	"spaceBetween": `CGMChart-module__space-between___DdRju`,
	"flexWrap": `CGMChart-module__flex-wrap___escd5`,
	"height100": `CGMChart-module__height-100___D55rQ`,
	"width50": `CGMChart-module__width-50___mj6i5`,
	"width100": `CGMChart-module__width-100___vElk5`,
	"cursorPointer": `CGMChart-module__cursor-pointer___KznID`,
	"cursorNotAllowed": `CGMChart-module__cursor-not-allowed___PAAIz`,
	"absoluteCentered": `CGMChart-module__absolute-centered___zpsz1`,
	"absolute": `CGMChart-module__absolute___Csnfq`,
	"relative": `CGMChart-module__relative___vHPMI`,
	"fixed": `CGMChart-module__fixed___BQBA_`,
	"visible": `CGMChart-module__visible___ml6Bk`,
	"invisible": `CGMChart-module__invisible___T7V2S`,
	"col90": `CGMChart-module__col-90___uGOJ9`,
	"colAuto": `CGMChart-module__col-auto___PU8ZG`,
	"medicalTabs": `CGMChart-module__medical-tabs___wbPji`,
	"medicalTableNew": `CGMChart-module__medical-table-new___BmNfv`,
	"noPagination": `CGMChart-module__no-pagination___AuXc7`,
	"medicalTableEmpty": `CGMChart-module__medical-table-empty___h1Lam`,
	"iconBtn": `CGMChart-module__icon-btn___XGbNd`,
	"searchIcon": `CGMChart-module__search-icon___uQ8bB`,
	"disableSelect": `CGMChart-module__disable-select___CGYqU`,
	"breakWord": `CGMChart-module__break-word___GrJWY`,
	"popupClearBtn": `CGMChart-module__popup-clear-btn___iIfiy`,
	"scrollMB20": `CGMChart-module__scroll-m-b-20___IZVLI`,
	"chart": `CGMChart-module__chart___OGODp`,
	"emptyPlaceholder": `CGMChart-module__emptyPlaceholder___bZQkh`
};
module.exports = ___CSS_LOADER_EXPORT___;
